import { useLocation } from "react-router";
import { routePermissions, type Route } from "@/auth/routes";
import { usePermissions } from "@/auth/permissions";
import UnauthorizedPage from "@/auth/unauthorized-page";
import LoadingIndicator from "@/ui/loading-indicator";
import type { JSX } from "react";

interface RequirePermissionsProps {
  children: JSX.Element;
}

/** Renders the route only for a caller holding every permission it requires. */
export default function RequirePermissions({
  children,
}: RequirePermissionsProps): JSX.Element {
  const location = useLocation();
  const { loading, can } = usePermissions();

  // Nothing is permitted until the answer arrives, so waiting is the difference
  // between an unauthorised page and a page that flashes one.
  if (loading) return <LoadingIndicator />;

  const required = routePermissions[location.pathname as Route];
  if (!required.every((permission) => can(permission))) {
    return <UnauthorizedPage />;
  }
  return children;
}
